import { render, staticRenderFns } from "./ValidationResultPopup.vue?vue&type=template&id=1d49ba08&scoped=true&"
import script from "./ValidationResultPopup.vue?vue&type=script&lang=js&"
export * from "./ValidationResultPopup.vue?vue&type=script&lang=js&"
import style0 from "./ValidationResultPopup.vue?vue&type=style&index=0&id=1d49ba08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d49ba08",
  null
  
)

export default component.exports